import React from 'react'
import logo from '../../img/logo.png'

class Hero extends React.Component {
	render() {
		return (
			<section className="hero">
				<div className="container">
					<div className="row d-flex align-items-center">
						<div className="col-12 col-md-6 col-lg-6">
							<div className="intro constraint">
								<h2 className="title">Discover your next adventure</h2>
								<p className="description">The Flight Post is an ad-free, open platform for writing and reading the latest trip reports. {`It's`} a place for aviation enthusiasts and travelers alike to share experiences from around the world.</p>
								<a className="btn btn-link" onClick={ this.props.onSignup }>Sign Up</a>
								
							</div>
						</div>
						<div className="col-12 col-md-6 col-lg-4 offset-lg-1">
							<img className="intro-img" src={ logo } />
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default Hero


// WEBPACK FOOTER //
// ./src/components/Home/Hero.js